module.exports = __webpack_public_path__ + "img/icon-default.445220ba.svg";